import type { QueryClient } from "@tanstack/react-query";

import { notificationQueryKeys } from "./query-keys";
import { notificationFiltersSchema } from "../schemas";
import type { NotificationData, NotificationsInfiniteData } from "../types";
import { LIVE_MATCH, matchLiveNotification, prependNotification } from "../utils";

export function applyLiveNotification(queryClient: QueryClient, notification: NotificationData) {
  const prepend = (prev: NotificationsInfiniteData | undefined) => prependNotification(prev, notification);

  for (const query of queryClient.getQueryCache().findAll({ queryKey: notificationQueryKeys.pages() })) {
    const filters = notificationFiltersSchema.safeParse(query.queryKey.at(-1));
    if (!filters.success) continue;

    const match = matchLiveNotification(filters.data, notification);
    if (match === LIVE_MATCH.MISS) continue;
    if (match === LIVE_MATCH.UNKNOWN) {
      void queryClient.invalidateQueries({ queryKey: query.queryKey, exact: true, refetchType: "none" });
      continue;
    }
    queryClient.setQueryData<NotificationsInfiniteData>(query.queryKey, prepend);
  }

  void queryClient.invalidateQueries({ queryKey: notificationQueryKeys.filters(), refetchType: "none" });
  void queryClient.invalidateQueries({ queryKey: notificationQueryKeys.unreadCount(), exact: true });
}
